import type { AccountCreateRequest } from "../schema/account";
import { public_api } from "./api";
import api from "./api";

const ACCOUNT_BASE_URL = "account";

export const createAccount = async (data: AccountCreateRequest) => {
  // if (DEMO_MODE) {
  //   // Mock API response for demo mode
  //   console.log('Demo mode: Creating account with data:', data);

  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 1000));

  //   // Mock successful response
  //   return {
  //     success: true,
  //     message: 'Account created successfully',
  //     account_id: 'demo-account-123',
  //     verification_email_sent: true
  //   };
  // }

  console.log(`${ACCOUNT_BASE_URL}/register`, data);
  const response = await public_api.post(`${ACCOUNT_BASE_URL}/register`, data, {
    timeout: 300000, // 5 minutes — demo data creation with 91 employees takes a while
  });
  console.log('Account created successfully', response);
  return response.data;
};

export const googleLogin = async (data: any) => {
  const response = await public_api.post(`${ACCOUNT_BASE_URL}/google-login`, data);
  console.log('Google login successful', response);
  return response.data;
};

export const verifyIdentity = async (data: { unique_id: string; date_of_birth: string }) => {
  const response = await public_api.post(`${ACCOUNT_BASE_URL}/verify-identity`, data);
  return response.data;
};

export const setPassword = async (data: { token: string; password: string }) => {
  console.log(`${ACCOUNT_BASE_URL}/set-password`, { token: data.token.substring(0, 20) + '...' });
  const response = await public_api.post(`${ACCOUNT_BASE_URL}/set-password`, {
    token: data.token,
    password: data.password,
  });
  console.log('Password set successfully', response);
  return response.data;
};

export const changePassword = async (data: { old_password: string; new_password: string }) => {
  const response = await api.post('/change-password', data);
  return response.data;
};

export const requestPasswordReset = async (data: { email: string }) => {
  console.log(`${ACCOUNT_BASE_URL}/forgot-password`, { email: data.email });
  const response = await public_api.post(`${ACCOUNT_BASE_URL}/forgot-password`, {
    email: data.email,
  });
  console.log('Password reset email sent', response);
  return response.data;
};

// Account settings API
export interface AccountSettings {
  account_uuid: number;
  company_name: string;
  company_id: string;
  domain: string;
  timezone: string;
  min_age: number;
  send_welcome_email: boolean;
  has_demo_data: boolean;
  logo?: string;
  created_at: string;
  modified_at: string;
}

export interface AccountSettingsResponse {
  success: boolean;
  data: AccountSettings;
}

export interface UpdateWelcomeEmailRequest {
  send_welcome_email: boolean;
}

export interface UpdateWelcomeEmailResponse {
  success: boolean;
  message: string;
  data: {
    account_uuid: number;
    send_welcome_email: boolean;
    modified_at: string;
  };
}

/**
 * Get account settings including welcome email setting
 */
export const getAccountSettings = async (): Promise<AccountSettings> => {
  const response = await api.get<AccountSettingsResponse>('/account');
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error('Failed to fetch account settings');
};

/**
 * Update welcome email setting
 */
export const updateWelcomeEmailSetting = async (
  sendWelcomeEmail: boolean
): Promise<UpdateWelcomeEmailResponse> => {
  const response = await api.put<UpdateWelcomeEmailResponse>(
    '/account/settings/welcome-email',
    { send_welcome_email: sendWelcomeEmail }
  );
  return response.data;
};

export interface DeleteDemoDataResponse {
  success: boolean;
  message: string;
  deleted_items: {
    table_name: string;
    rows_affected: number;
  }[];
}

/**
 * Delete all demo data for the current account
 */
export const deleteDemoData = async (): Promise<DeleteDemoDataResponse> => {
  const response = await api.delete<DeleteDemoDataResponse>('/account/demo-data');
  return response.data;
};

export interface ResendWelcomeEmailRequest {
  email: string;
  user_uuid: string;
  account_uuid: string;
  first_name: string;
}

export interface ResendWelcomeEmailResponse {
  success: boolean;
  message: string;
}

/**
 * Resend welcome/verification email
 */
export const resendWelcomeEmail = async (data: ResendWelcomeEmailRequest): Promise<ResendWelcomeEmailResponse> => {
  console.log('Resend welcome email payload:', data);
  const response = await public_api.post<ResendWelcomeEmailResponse>('account/send-mail/welcome', data);
  return response.data;
};
